import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { disabled, email, form, FormField, readonly, required } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EmailDto } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '../../../../abstract';

@Component({
  selector: 'aura-contact-infos-email-form',
  templateUrl: './contact-infos-email-form.component.html',
  imports: [FormField, MatFormFieldModule, MatInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraContactInfosEmailFormComponent extends AbstractSignalFormComponent<EmailDto> {
  override model: WritableSignal<EmailDto> = signal({ email: '' });

  override formTree = form(this.model, (b) => {
    required(b.email, { when: () => this.isRequired('email') });
    email(b.email);
    readonly(b.email, { when: () => this.allReadonly() });
    disabled(b.email, { when: () => this.allDisable() });
  });
}
